import { StaticEffect } from './effects/static.effects';
import { FeaturesEffects } from './effects/features.effects';
import { SharedEffects } from './effects/shared.effect';
import { RouterEffects } from './effects/router.effects';
import { FestivalEffects } from './effects/festival.effect';

export const rootEffects = [
  FeaturesEffects,
  SharedEffects,
  StaticEffect,
  RouterEffects,
  FestivalEffects
];